import React from "react";
import Thumbnail from "./components/Thumbnail";
import { DayUseServiceIcons } from "../../../../../assets/SVGIcons";
import styles from "./RegistrationScreenNav.module.scss";

const RegistrationScreenNav = ({ setView, view }) => {
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Thumbnail
          subTitle={"Register your details"}
          size={{
            width: "64px",
            height: "64px",
          }}
          icon={DayUseServiceIcons.List}
          onClick={() => setView({ type: "registration-view-form" })}
          active
        />
      </div>
      <div className={styles.item}>
        <Thumbnail
          subTitle={"Secure your reservation"}
          size={{
            width: "64px",
            height: "64px",
          }}
          icon={DayUseServiceIcons.CreditCard}
          active={[
            "registration-view-add-card",
            "registration-view-preconfirm-view",
          ].includes(view.type)}
        />
      </div>
      <div className={styles.item}>
        <Thumbnail
          subTitle={"Reserve"}
          size={{
            width: "64px",
            height: "64px",
          }}
          icon={DayUseServiceIcons.Basket(48, "white")}
          active={["registration-view-preconfirm-view"].includes(view.type)}
        />
      </div>
    </div>
  );
};

export default RegistrationScreenNav;
